export default "__VITE_ASSET__udLKMW9X__"